import React from "react";
import PropTypes from "prop-types";

import "./LinkCard.scss";

import BROWSE_VEHICLES from "../../assets/images/icons/browse-electric-vehicles.svg"
import DISCOVER_INCENTIVES from "../../assets/images/icons/discover-incentives.svg";
import LOCATE_CHARGING_STATIONS from "../../assets/images/icons/locate-charging-stations.svg";
// import EV_FACTS from "../../client_customizations/assets/images/icons/ev-facts.svg";
import BACK_TO_IID from "../../assets/images/icons/iid.svg"
import FIND_DEALERS from "../../assets/images/icons/find-dealers.svg"
import HOME_CHARGERS from "../../assets/images/icons/home-chargers.svg"
import { Link } from "react-router-dom";
import {FormattedMessage} from 'react-intl';
import SmoothScroll from "../../../utils/Helpers/SmoothScroll"

const LinkCard = ({ type }) => {
  let src, alt, link, scrollTo, title, target;

  switch (type) {
    case "BROWSE_VEHICLES":
      src = BROWSE_VEHICLES;
      alt = "Electric Vehicle"
      scrollTo = "HomepageVehiclesCarousel";
      title = (
        <span>
          <FormattedMessage
            id="homepage.linkCard.browseElectricVehicles"
            defaultMessage="BROWSE ELECTRIC VEHICLES"
            description="Browse electric vehicles linkcard"
            values= {{
              lineBreak: <br />
            }}
          />
        </span>
      );
      break;
    case "DISCOVER_INCENTIVES":
      src = DISCOVER_INCENTIVES;
      alt = "Money Bag"
      scrollTo = "HomepageIncentives";
      title = (
        <span>
          <FormattedMessage
            id="homepage.linkCard.discoverIncentives"
            defaultMessage="DISCOVER INCENTIVES"
            description="discover incentives linkcard"
            values= {{
              lineBreak: <br />
            }}
          />
        </span>
      );
      break;
    case "LOCATE_CHARGING_STATIONS":
      src = LOCATE_CHARGING_STATIONS;
      alt = "Charging Station"
      link = "/charging-stations";
      title = (
        <span>
          <FormattedMessage
            id="homepage.linkCard.locateChargingStations"
            defaultMessage="LOCATE CHARGING STATIONS"
            description="locate charging stations linkcard"
            values= {{
              lineBreak: <br />
            }}
          />
        </span>
      );
      break;
    case "FIND_DEALERS":
      src = FIND_DEALERS;
      alt = "Car Key"
      link = "/dealers";
      title = (
        <span>
          FIND <br />
          DEALERS
        </span>
      );
      break;
    case "HOME_CHARGERS":
      src = HOME_CHARGERS;
      alt = "Home Chargers"
      link = "/home-chargers";
      title = (
        <span>
          <FormattedMessage
            id="homepage.linkCard.homeChargers"
            defaultMessage="HOME CHARGERS"
            description="home chargers linkcard"
            values= {{
              lineBreak: <br />
            }}
          />
        </span>
      );
      break;
    case "IID":
      src = BACK_TO_IID;
      alt = "IID"
      link = {pathname: "https://www.iid.com"}
      title = (
        <span>
          BACK TO <br />
          IID.COM
        </span>
      );
      target = "_blank"
      break;
    default:
      return null;
  }

  return scrollTo ? (
    <div className="link-card">
      <div className="inside-link-card" onClick={e => SmoothScroll(scrollTo)}>
        <div>
          <img src={src} alt={alt} />
          <p className="h3">{title}</p>
        </div>
      </div>
    </div>
  ) : (
    <div className="link-card">
      <Link to={link} className="inside-link-card" target={target}>
          <img src={src} alt={alt} />
          <p className="h3">{title}</p>
      </Link>
    </div>
  );
};

export default LinkCard;

LinkCard.propTypes = {
  type: PropTypes.string
};
